module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAABaklEQVQ4jZXTvWtVQRAF8N99eSYhqEQlz0aEgJ1Y2YvC9iL+AVaW6cQqlRCwjRAQtBBB8aOzEdxLOu1EOy0iCmJhoSGKCiYvWuwELtd7ox4Ydndm9uyZ3dkq5zyFeziIKgy2MY2buKEHKSUwxAN8xrmOvHk8wxus9pFBlXPewC2sB3ET61jELJY74lt4lFJarXLOa3iK7xhEwi+MY/0BezCKcitMxHyI81ga4gsu7Cb7L7iOx4Ngn28F5/AkxiYyTjcdKaXneDHQjU/4incNX41jeNlMrOt6hj8vbwfbSu3Xwl5jskM50TJ9ik7iPvZiASv4hts407WhT9F73MEP7Feef0lp2rX/IdqHE0obHMUMTkUZb+OgfyKaxAHlrqbCZpW+mt5N0WbL/wqXYj7CEVzuOXQT4wEOKU3ZhxVc6QumlH5iVOWc6yjhovIyE63cjzEebvnHSplXcXznrzzE3ZDZJurDWPmDcPY31ldRp2b9QesAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/12.png
// module id = xyec
// module chunks = 0